/**
 * Resource Catalog Configuration
 * Defines available downloadable resources
 */

// Use local test resources in development, CDN in production
const IS_DEV = import.meta.env.DEV;
const THUMBNAIL_BASE = IS_DEV
  ? '/test-resources/thumbnails'
  : 'https://cdn.educ4te.com/resources/thumbnails';

export const resources = [
  {
    id: 'copilot-90-day-security-roadmap',
    title: '90-Day Copilot Security Roadmap: Essential Eight-Aligned Framework',
    description: 'A complete 90-day Essential Eight-aligned security roadmap for enabling Microsoft 365 Copilot Wave 3. Covers all eight controls mapped to Copilot, ASD Blueprint configuration tiers, Copilot Studio multi-agent governance, and the audit evidence Australian auditors and IRAP assessors require.',
    category: 'Guides',
    type: 'ebook',
    fileSize: '0.37 MB',
    fileName: 'copilot-90-day-security-roadmap.pdf',
    thumbnail: `${THUMBNAIL_BASE}/default.svg`,
    leadMagnet: true,
    dateAdded: '2026-05-04',
    tags: ['Essential Eight', 'Microsoft Copilot', 'Wave 3', 'ASD Blueprint', 'Copilot Studio', 'IRAP', 'Australian Compliance']
  },
  {
    id: 'copilot-governance-compliance-playbook',
    title: 'Copilot Governance & Compliance Playbook for Australian Organisations',
    description: 'The complete governance and compliance playbook for Microsoft 365 Copilot in Australian organisations. Covers Microsoft Purview data protection, SharePoint and Teams governance, the Copilot Cowork data residency gap, Work IQ privacy obligations, and IRAP in-country processing.',
    category: 'Guides',
    type: 'ebook',
    fileSize: '0.35 MB',
    fileName: 'copilot-governance-compliance-playbook.pdf',
    thumbnail: `${THUMBNAIL_BASE}/default.svg`,
    leadMagnet: true,
    dateAdded: '2026-05-04',
    tags: ['Microsoft Purview', 'Compliance & Governance', 'Data Residency', 'Privacy Act', 'IRAP', 'Work IQ', 'Australian Compliance']
  },
  {
    id: 'copilot-essential-eight-alignment-checklist',
    title: 'Copilot Essential Eight Alignment Checklist',
    description: 'A printable checklist mapping all eight ACSC Essential Eight controls to Microsoft 365 Copilot Wave 3 requirements. Covers application control for agents, phishing-resistant MFA, least-privilege permissions, and the five additional controls beyond Essential Eight.',
    category: 'Checklists',
    type: 'checklist',
    fileSize: '0.1 MB',
    fileName: 'copilot-essential-eight-alignment-checklist.pdf',
    thumbnail: `${THUMBNAIL_BASE}/default.svg`,
    leadMagnet: false,
    dateAdded: '2026-05-04',
    tags: ['Essential Eight', 'Microsoft Copilot', 'Checklist', 'Australian Compliance']
  },
  {
    id: 'copilot-pre-deployment-controls-checklist',
    title: 'Copilot Pre-Deployment Controls Checklist',
    description: 'A comprehensive pre-deployment checklist covering the ASD Blueprint Required tier, sensitivity labels, DLP policies, and privacy governance controls every Australian organisation must complete before enabling Copilot.',
    category: 'Checklists',
    type: 'checklist',
    fileSize: '0.1 MB',
    fileName: 'copilot-pre-deployment-controls-checklist.pdf',
    thumbnail: `${THUMBNAIL_BASE}/default.svg`,
    leadMagnet: false,
    dateAdded: '2026-05-04',
    tags: ['Microsoft Copilot', 'ASD Blueprint', 'Pre-Deployment', 'Checklist', 'Australian Compliance']
  },
  {
    id: 'copilot-privacy-act-irap-checklist',
    title: 'Copilot Privacy Act & IRAP Compliance Checklist',
    description: 'A targeted checklist for Australian organisations assessing Privacy Act 1988 obligations and IRAP alignment for Microsoft 365 Copilot. Covers APP 8 Cowork cross-border disclosure, Work IQ APP 5 notifications, and ASD Blueprint customer configuration gap.',
    category: 'Checklists',
    type: 'checklist',
    fileSize: '0.1 MB',
    fileName: 'copilot-privacy-act-irap-checklist.pdf',
    thumbnail: `${THUMBNAIL_BASE}/default.svg`,
    leadMagnet: false,
    dateAdded: '2026-05-04',
    tags: ['Privacy Act', 'IRAP', 'Microsoft Copilot', 'Checklist', 'Australian Compliance']
  },
  {
    id: 'copilot-wave-2-agents-governance-checklist',
    title: 'Copilot Wave 2 Agents Governance Checklist',
    description: 'A governance checklist for Microsoft 365 Copilot Wave 2 agent deployments. Covers Copilot Pages governance, SharePoint agents, Teams community agents, and the information architecture prerequisites for agent readiness in Australian organisations.',
    category: 'Checklists',
    type: 'checklist',
    fileSize: '0.1 MB',
    fileName: 'copilot-wave-2-agents-governance-checklist.pdf',
    thumbnail: `${THUMBNAIL_BASE}/default.svg`,
    leadMagnet: false,
    dateAdded: '2026-05-04',
    tags: ['Microsoft Copilot', 'Wave 2', 'Agents', 'Governance', 'Checklist', 'Australian Compliance']
  },
  {
    id: 'copilot-wave-3-agentic-shift-guide',
    title: 'Copilot Wave 3 & the Agentic Shift: An Australian Decision-Maker\'s Guide',
    description: 'Wave 3 makes Copilot autonomous. Covers Agent 365, Researcher and Analyst agents, agentic features across Word, Excel, PowerPoint and Outlook, and the governance decisions Australian IT leaders must make before enabling agentic AI.',
    category: 'Guides',
    type: 'ebook',
    fileSize: '0.35 MB',
    fileName: 'copilot-wave-3-agentic-shift-guide.pdf',
    thumbnail: `${THUMBNAIL_BASE}/copilot-wave-3-agentic.svg`,
    leadMagnet: true,
    dateAdded: '2026-05-04',
    tags: ['Microsoft Copilot', 'Wave 3', 'Agent 365', 'Agentic AI', 'Frontier Suite', 'Australian Compliance']
  },
  {
    id: 'copilot-waves-1-2-foundation-guide',
    title: 'Microsoft 365 Copilot Waves 1 & 2: The Australian IT Leader\'s Foundation Guide',
    description: 'Covers Wave 1 GA (November 2023) and Wave 2 (September 2024) — architecture, ASD Blueprint configuration tiers, pre-deployment controls, and the shift to agents and the Copilot Control System. Free download for Australian IT leaders.',
    category: 'Guides',
    type: 'ebook',
    fileSize: '0.42 MB',
    fileName: 'copilot-waves-1-2-foundation-guide.pdf',
    thumbnail: `${THUMBNAIL_BASE}/copilot-waves-foundation.svg`,
    leadMagnet: true,
    dateAdded: '2026-04-29',
    tags: ['Microsoft Copilot', 'Wave 1', 'Wave 2', 'ASD Blueprint', 'Essential Eight', 'Australian Compliance']
  },
  {
    id: 'ai-race-cv-coach',
    title: 'AI RACE CV Coach',
    description: 'Comprehensive guide to optimizing your CV using AI-powered techniques and best practices for standing out in modern recruitment processes.',
    category: 'Guides',
    fileSize: '4.35 MB',
    fileName: 'AI RACE CV Coach.pdf',  // Actual filename in R2
    thumbnail: `${THUMBNAIL_BASE}/default.svg`,
    dateAdded: '2026-03-09'
  },
  {
    id: 'ai-race-interview-coach',
    title: 'AI RACE Interview Coach',
    description: 'Expert interview preparation guide leveraging AI tools and strategies to excel in technical and behavioral interviews.',
    category: 'Guides',
    fileSize: '250 KB',
    fileName: 'AI RACE Interview Coach.pdf',  // Actual filename in R2
    thumbnail: `${THUMBNAIL_BASE}/default.svg`,
    dateAdded: '2026-03-09'
  }
];

/**
 * Get resource by ID
 */
export function getResourceById(id) {
  return resources.find(r => r.id === id);
}

/**
 * Get resources by category
 */
export function getResourcesByCategory(category) {
  if (category === 'All') return resources;
  return resources.filter(r => r.category === category);
}

/**
 * Get all unique categories
 */
export function getCategories() {
  const categories = [...new Set(resources.map(r => r.category))];
  return ['All', ...categories];
}
